import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchGetHouseStatsDesktop,
  TGetHouseStatsDesktopResponse,
} from '../../repositories/newbuilding-card/v1/get-house-stats-desktop';
import { selectHouseId, setHouseStats } from '../../slices/offers';
import { IThunkApi } from '../../types/redux';

export const fetchStats = createAsyncThunk<void, number | undefined, IThunkApi>(
  'offers/fetchStats',
  async (houseId, thunkApi) => {
    const {
      dispatch,
      getState,
      extra: { logger, httpApi },
    } = thunkApi;

    try {
      const state = getState();

      if (houseId && state.offers && !state.offers.data[houseId]) {
        const parameters = {
          houseId,
          newbuildingId: state.newbuilding.id,
        };
        const response: TGetHouseStatsDesktopResponse = await fetchGetHouseStatsDesktop({
          httpApi,
          parameters,
        });

        if (response.statusCode === 400) {
          throw response.response.message;
        }

        const payload = {
          houseId,
          stats: response.response.stats || null,
        };

        dispatch(setHouseStats(payload));
      }

      dispatch(selectHouseId(houseId));
    } catch (error) {
      logger.error(error, {
        houseId,
        domain: 'fetchStats',
      });
    }
  },
);
